<div *ngIf="field.formControl.status === 'INVALID'">
	<div class="validation-message-container">
		<div class="validation-message ellipsis-text">
			<formly-validation-message
				[field]="field">
			</formly-validation-message>
		</div>
	</div>
</div>